import { RegisterProductsForm } from "../../Components/FormRegisterProducts";
import { useProducts } from "../../Providers/Products";
import { RegisterServiceForm } from "../../Components/FormRegisterServices";
import { useServices } from "../../Providers/Services";
import { useEffect, useState } from "react";
import {
  ButtonNewContainer,
  ButtonsNavContainer,
  Container,
  IntraContainer,
  Item,
  List,
} from "./styles";
import Button from "../../Components/Button";
import Footer from "../../Components/Footer";
import ModalElement from "../../Components/Modal";
import CardProductOrService from "../../Components/CardProductOrService";
import { IProductAPI, IServiceAPI } from "../../Interfaces";
import { ListCardBox } from "../../Components/ListCardBox";

const ProductsAndServices = () => {
  const [showProducts, setShowProducts] = useState(true);

  const [modalAddIsOpen, setAddIsOpen] = useState(false);

  const { products, addNewProduct } = useProducts();
  const { services, addNewService } = useServices();
  const [prodsState, setProdsState] = useState<IProductAPI[]>(products);
  const [servicesState, setServicesState] = useState<IServiceAPI[]>(services);

  const handleModalAddIsOpen = () => {
    setAddIsOpen(!modalAddIsOpen);
  };

  useEffect(() => {
    if (products !== undefined) {
      setProdsState(products);
    }
  }, [products]);

  useEffect(() => {
    if (services !== undefined) {
      setServicesState(services);
    }
  }, [services]);

  useEffect(() => {}, [prodsState, servicesState]);

  return (
    <Container>
      <ButtonsNavContainer>
        <Button
          className={showProducts ? "focusedProducts" : "products"}
          onClick={() => setShowProducts(true)}
        >
          Products
        </Button>
        <Button
          className={!showProducts ? "focusedServices" : "services"}
          onClick={() => setShowProducts(false)}
        >
          Services
        </Button>
      </ButtonsNavContainer>
      {showProducts ? (
        <IntraContainer>
          <ListCardBox height="50vh">
            {prodsState?.map((product, index) => (
              <CardProductOrService
                infs={product}
                key={index}
                type="product"
                setProds={setProdsState}
                prods={prodsState}
              />
            ))}
          </ListCardBox>
          <ButtonNewContainer>
            <Button className={"addButton"} onClick={handleModalAddIsOpen}>
              Novo
            </Button>
          </ButtonNewContainer>
          <ModalElement
            isOpen={modalAddIsOpen}
            closeModal={handleModalAddIsOpen}
          >
            <RegisterProductsForm
              handleForm={addNewProduct}
              buttonName="Cadastrar"
              handleModal={handleModalAddIsOpen}
            />
          </ModalElement>
        </IntraContainer>
      ) : (
        <IntraContainer>
          <ListCardBox height="50vh">
            {services?.map((service, index) => (
              <CardProductOrService
                infs={service}
                key={index}
                setServices={setServicesState}
                type="service"
                services={servicesState}
              />
            ))}
          </ListCardBox>
          <ButtonNewContainer>
            <Button className={"addButton"} onClick={handleModalAddIsOpen}>
              Novo
            </Button>
          </ButtonNewContainer>
          <ModalElement
            isOpen={modalAddIsOpen}
            closeModal={handleModalAddIsOpen}
          >
            <RegisterServiceForm
              handleForm={addNewService}
              buttonName="cadastrar"
              handleModal={handleModalAddIsOpen}
            />
          </ModalElement>
        </IntraContainer>
      )}
      <Footer />
    </Container>
  );
};
export default ProductsAndServices;
